import React from 'react';

export const modalIds = {
  enquiry: 'enquiry',
  bookTour: 'bookTour',
};

const { Provider, Consumer } = React.createContext({
  currentModal: '',
  openModal() {},
  closeModal() {},
  formFields: '',
});

class ModalsProvider extends React.Component {
  state = {
    currentModal: '',
    formFields: {},
  };

  openModal = (modalId, formFields) => {
    this.setState({ currentModal: modalId, formFields: formFields });
  };

  closeModal = () => this.setState({ currentModal: '' });

  render() {
    return (
      <Provider
        value={{
          currentModal: this.state.currentModal,
          openModal: this.openModal,
          closeModal: this.closeModal,
          formFields: this.state.formFields,
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { ModalsProvider, Consumer as ModalsConsumer };
